import React from "react";

export default function Expand({
  size = 20,
  color = "#000000",
  strokeWidth = 2,
  className,
  title,
  ...props
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={title ? undefined : "true"}
      role="img"
      {...props}
    >
      {title ? <title>{title}</title> : null}

      <g>
        <line x1="19" y1="1" x2="12.73" y2="7.27" />
        <polyline points="14.29 1 19 1 19 5.71" />
      </g>
      <g>
        <line x1="1" y1="1" x2="7.27" y2="7.27" />
        <polyline points="1 5.71 1 1 5.71 1" />
      </g>
      <g>
        <line x1="1" y1="19" x2="7.27" y2="12.73" />
        <polyline points="5.71 19 1 19 1 14.29" />
      </g>
      <g>
        <line x1="19" y1="19" x2="12.73" y2="12.73" />
        <polyline points="19 14.29 19 19 14.29 19" />
      </g>
    </svg>
  );
}
